import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchStories } from "../../redux/stories/storySlice";
import { updateSearchString } from "../../redux/filters/filterSlice";
import { setLoaderState } from "../../redux/loader/loaderSlice";
import { pushHistory } from "../../helpers/history";
import StoryItem from "./StoryItem";
import Pagination from "../ui/Pagination";

function StoryResults() {
  const dispatch = useDispatch();
  const stories = useSelector((state) => state.story.items);
  const filtersLoadingStatus = useSelector((state) => state.filters.status);
  const filterSearchString = useSelector((state) => state.filters.searchString);
  const isUpdatedFromUrl = useSelector(
    (state) => state.filters.isUpdatedFromUrl
  );
  const currentPage = useSelector((state) => state.pagination.currentPage);
  const loadingStatus = useSelector((state) => state.story.status);
  const dictionary = useSelector((state) => state.localization.dictionary);

  useEffect(() => {
    if (filtersLoadingStatus === "resolved") {
      dispatch(
        fetchStories({
          currentPage,
        })
      );
      dispatch(
        updateSearchString({
          currentPage,
        })
      );
    }
  }, [filtersLoadingStatus, currentPage]);

  useEffect(() => {
    if (isUpdatedFromUrl) {
      pushHistory(filterSearchString);
    }
  }, [filterSearchString]);

  useEffect(() => {
    if (loadingStatus === "loading") {
      dispatch(setLoaderState(true));
    }

    if (loadingStatus === "resolved") {
      dispatch(setLoaderState(false));
    }

    if (loadingStatus === "rejected") {
      dispatch(setLoaderState(false));
    }
  }, [loadingStatus]);

  if (
    !stories?.totalElements &&
    !stories?.content &&
    stories?.totalPages == 1
  ) {
    return (
      <div className="row stories-list">
        <p>{dictionary["CNHS.Filter.NoResultsMessage"]}</p>
      </div>
    );
  }

  return stories?.totalElements > 0 ? (
    <div className="row stories-list">
      <span id="stories"></span>
      {stories?.content.map((story, index) => {
        return <StoryItem story={story} key={`story-item-${index}`} />;
      })}
      <div id="pagination" className="row">
        <div id="pagination" className="columns small-12">
          {stories?.totalPages > 1 ? <Pagination results={stories} /> : null}
        </div>
      </div>
    </div>
  ) : null;
}

export default StoryResults;
